import { MapMarker } from '../models/mapModel';

export const filterDuplicateMarkers = (markers: MapMarker[] | null): MapMarker[] => {
    if (!markers) return [];
    const formattedMarkers: MapMarker[] = [];

    Array.isArray(markers) &&
        markers.forEach((marker) => {
            if (
                !formattedMarkers.some(({ lat, lng }) => lat === marker.lat && lng === marker.lng)
            ) {
                formattedMarkers.push(marker);
            }
        });

    return formattedMarkers;
};
